<!-- =========================================================================================
  File Name: BreakView.vue
  Description: User View page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div id="page-user-view">
		<vs-alert color="danger" :title="$t('BreakNotFound.Title')" :active.sync="break_not_found">
			{{ $t("BreakNotFound.Text1") + " " + $route.params.id + " " + $t("BreakNotFound.Text2") }}
			<span>
				<span>{{ $t("Check") }} </span>
				<router-link :to="{name: 'BreaksListView'}" class="text-inherit underline">{{
					$t("ListOfBreaks")
				}}</router-link>
			</span>
		</vs-alert>
		<div id="user-data" v-if="breakData">
			<vx-card :title="$t('Information')" class="mb-base">
				<div class="vx-row">
					<div class="vx-col flex-1" id="account-info-col-1">
						<table>
							<caption></caption>
							<thead>
								<tr>
									<th scope="col"></th>
								</tr>
							</thead>
							<tr>
								<td class="font-semibold">{{ $t("Routing.Table.Identification") }}</td>
								<td>{{ breakData.id }}</td>
							</tr>
							<tr>
								<td class="font-semibold">{{ $t("Routing.Table.Name") }}</td>
								<td>{{ breakData.name }}</td>
							</tr>
						</table>
					</div>

					<div class="vx-col flex-1" id="account-info-col-2">
						<table>
							<caption></caption>
							<thead>
								<tr>
									<th scope="col"></th>
								</tr>
							</thead>
							<tr>
								<td class="font-semibold">{{ $t("TimeWindow.Duration") }}</td>
								<td>{{ breakData.duration }}</td>
							</tr>
						</table>
					</div>

					<div class="vx-col w-full flex mt-base justify-end" id="account-manage-buttons">
						<vs-button
							type="border"
							icon-pack="feather"
							icon="icon-edit"
							class="mr-4"
							color="success"
							:title="windowWidth > 620 ? null : $t('Crud.Update')"
							:size="iconSize"
							:to="{
								name: 'UpdateBreak',
								params: {id: $route.params.id},
							}"
							>{{ windowWidth > 620 ? $t("Crud.Update") : null }}
						</vs-button>
						<vs-button
							type="border"
							color="danger"
							icon-pack="feather"
							icon="icon-trash"
							class="mr-4"
							:title="windowWidth > 620 ? null : $t('Crud.Delete')"
							:size="iconSize"
							@click="confirmDeleteRecord"
							>{{ windowWidth > 620 ? $t("Crud.Delete") : null }}
						</vs-button>
						<vs-button
							type="border"
							color="primary"
							icon-pack="feather"
							icon="icon-list"
							:title="windowWidth > 620 ? null : $t('ListOfBreaks')"
							:size="iconSize"
							:to="{name: 'BreaksListView'}"
							>{{ windowWidth > 620 ? $t("ListOfBreaks") : null }}</vs-button
						>
					</div>
				</div>
				<vs-divider class="mt-base mb-base"></vs-divider>
				<template lang="html">
					<vs-tabs>
						<vs-tab
							:label="$t('TimeWindow.Schedule') | capitalize"
							icon-pack="feather"
							icon="icon-calendar"
							class="mb-base mt-base"
						>
							<time-calendar
								ref="timeCalendar"
								:viewData="true"
								:isMaximize="false"
								:cronExpression="breakData.cron"
								:duration="breakData.duration ? breakData.duration : '12:00:00'"
							/>
						</vs-tab>
						<vs-tab
							:label="$t('Vehicles.AssignedVehicles') | capitalize"
							icon-pack="feather"
							icon="icon-users"
							class="mb-base mt-base"
						>
							<vehicle-assigned-list
								v-if="vehicleIds.length > 0"
								:isDemand="false"
								:vehicle_ids="vehicleIds"
								:remove="false"
								:redirect="true"
								:showActions="false"
							></vehicle-assigned-list>
							<vx-card v-else no-shadow card-border>
								<vs-alert active class="mb-5" color="primary">
									<span> {{ $t("Vehicles.NoAssignedVehicles") }} </span>
								</vs-alert>
							</vx-card>
						</vs-tab>
					</vs-tabs>
				</template>
			</vx-card>
		</div>
	</div>
</template>

<script>
import vSelect from "vue-select";
import "swiper/dist/css/swiper.min.css";
import {swiper, swiperSlide} from "vue-awesome-swiper";
import TimeCalendar from "@/components/shared/TimeCalendar.vue";
import moduleBreaks from "@/store/breaks/moduleBreaks.js";
import VehicleAssignedList from "@/components/vehicle/list/VehicleAssignedList.vue";

export default {
	components: {
		vSelect,
		swiper,
		swiperSlide,
		TimeCalendar,
		VehicleAssignedList,
	},
	data() {
		return {
			breakData: null,
			break_not_found: false,
			settings: {
				maxScrollbarLength: 60,
				wheelSpeed: 0.6,
			},
		};
	},
	computed: {
		vehicleIds() {
			return this.breakData["vehicle_id"] && this.breakData["vehicle_id"] !== null
				? this.breakData["vehicle_id"]
				: [];
		},
		windowWidth() {
			return this.$store.state.windowWidth;
		},
		iconSize() {
			return this.$store.state.windowWidth < 620 ? "small" : "medium";
		},
	},
	methods: {
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		confirmDeleteRecord() {
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Confirm"),
				text: this.$t("DeleteBreak"),
				accept: this.deleteRecord,
				acceptText: this.$t("Accept"),
				cancelText: this.$t("Cancel"),
			});
		},
		deleteRecord() {
			/* Below two lines are just for demo purpose */
			this.$store
				.dispatch("moduleBreaks/removeItem", this.breakData.id)
				.then((res) => {
					this.$router.push({name: "BreaksListView"});
					this.showDeleteSuccess();
				})
				.catch((err) => {
					console.error(err);
				});
		},
		showDeleteSuccess() {
			this.$vs.notify({
				color: "success",
				title: this.$t("TitleConfirmBreakDelete"),
				text: this.$t("TextConfirmBreakDelete"),
			});
		},
	},
	created() {
		if (!moduleBreaks.isRegistered) {
			this.$store.registerModule("moduleBreaks", moduleBreaks);
			moduleBreaks.isRegistered = true;
		}
		const id = parseInt(this.$route.params.id);
		this.openLoading();
		this.$store
			.dispatch("moduleBreaks/findBreaksFilter", {id: [id]})
			.then((res) => {
				this.breakData = res.records[0];
				this.closeLoading();
				return res.records;
			})
			.catch((err) => {
				this.closeLoading();
				if (err.status === 400) {
					this.break_not_found = true;
					return;
				}
				console.error(err);
			});
	},
};
</script>

<style lang="scss">
#avatar-col {
	width: 10rem;
}

#page-user-view {
	table {
		td {
			vertical-align: top;
			min-width: 140px;
			padding-bottom: 0.8rem;
			word-break: break-all;
		}

		&:not(.permissions-table) {
			td {
				@media screen and (max-width: 370px) {
					display: block;
				}
			}
		}
	}
}

@media screen and (min-width: 1201px) and (max-width: 1211px),
	only screen and (min-width: 636px) and (max-width: 991px) {
	#account-info-col-1 {
		width: calc(100% - 12rem) !important;
	}
}
.scroll-area {
	margin: auto;
	width: 100%;
	min-height: 400px;
	max-height: 450px;
}
</style>
